// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import JobsList from './PageComponent/JobsList';

function Jobs() {

    useMeta({
        title: 'Career | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/career/jobs/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Career | Callistus Blinds',
            description:
                'Callistus Blinds is on an exciting growth path. We invite result oriented professionals to build a career with us. We would be happy to receive applications in various functional areas. Join us to experience a fulfilling career.',
            url: 'https://callistusblinds.com/career/jobs/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <JobsList />
            <Footer />
        </div>
    );
}

export default Jobs;
